// extracted by mini-css-extract-plugin
module.exports = {"Button":"y_r5 t_r5 t_rT g_fl g_fz g_fp g_g9","full":"y_s4 g_dl g_dw","width100":"y_dl g_dl","design3Pos":"y_s5 g_dQ"};